import { IUniversalField } from "../../interfaces/iuniversal-field";


///View Model for the Link Universalfield Type
class LinkTagViewModel {

    ///Assigns the ID, Universalfield Data ,Universalfield Value Data and the Parent
    constructor(shiftReportTagTab, tagId) {
        this.TagId = tagId;
        this.Parent = shiftReportTagTab;
        this.TagViewModel = this.Parent.getTagModel(this.TagId);
        this.TagValueModel = this.Parent.getTagObservable(this.TagId);
    }

    ///Contains the Universalfield Data
    TagViewModel: IUniversalField = null;

    ///Contains the Universalfield Value Data
    TagValueModel = null;

    ///Id if the Universalfield 
    TagId: string = null;

    ///Contains the parent ShiftReportTagTab View Model
    Parent: any = null;

    ///Opens the given Link from the Source Property in a new browser Tab
    public OpenLinkInNewTab = () => {
        if (this.TagViewModel.Source != null && this.TagViewModel.Source != undefined) {
            window.open(this.TagViewModel.Source, '_blank');
        }
    }
}

export default LinkTagViewModel;